(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-page-nav"] && !Shopify.designMode) return;
  try {
    class CollectionPageNav extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.navLinks = this.querySelectorAll("a");
        this._boundHandleClick = this.handleClick.bind(this);
        this._boundHandlePopState = this.handlePopState.bind(this);

        this.navLinks.forEach(link => {
            link.addEventListener('click', this._boundHandleClick);
        });

        window.addEventListener('popstate', this._boundHandlePopState);
    }

    disconnectedCallback() {
        this.navLinks.forEach(link => {
            link.removeEventListener('click', this._boundHandleClick);
        });
        window.removeEventListener('popstate', this._boundHandlePopState);
    }

    handleClick(event) {
        event.preventDefault();
        const link = event.currentTarget;

        this.navLinks.forEach(link => link.classList.remove('mm_collection-page-nav--selected'));
        link.classList.add('mm_collection-page-nav--selected');

        fetch(link.href + "?sections=collection-banner,main-collection")
            .then(res => {
                if (!res.ok) throw new Error("Network response was not ok");
                return res.json();
            })
            .then(data => {
                const collectionBannerDiv = document.querySelector(".shopify-section--collection-banner");
                const mainCollectionDiv = document.querySelector(".shopify-section--main-collection");

                const tempCollectionBannerDiv = document.createElement('div');
                const tempMainCollectionDiv = document.createElement('div');

                if (data["collection-banner"] && collectionBannerDiv) {
                    tempCollectionBannerDiv.innerHTML = data["collection-banner"];
                    collectionBannerDiv.querySelector('.page-header__text-wrapper').innerHTML = tempCollectionBannerDiv.querySelector('.page-header__text-wrapper').innerHTML;
                }

                if (data["main-collection"] && mainCollectionDiv) {
                    tempMainCollectionDiv.innerHTML = data["main-collection"];
                    mainCollectionDiv.querySelector('#facet-main').innerHTML = tempMainCollectionDiv.querySelector('#facet-main').innerHTML;
                }

                window.history.replaceState({}, "", link.href);
            })
            .catch(error => {
                console.error("Error fetching sections:", error);
                window.location.href = link.href; // fallback
            });
    }

    handlePopState(event) {
        // On back/forward, just reload the page normally
        window.location.href = window.location.href;
    }
}

if (!customElements.get('collection-page-nav')) {
  customElements.define('collection-page-nav', CollectionPageNav);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-2025-cross-sell"] && !Shopify.designMode) return;
  try {
    document.addEventListener("change", function(e) {
  if (e.target.matches('.cross-sell-color-swatch input[type="radio"]')) {
    const swatch = e.target.closest(".cross-sell-color-swatch");
    if (swatch) {
      const hiddenInput = swatch.closest(".pdp-cross-sell-item")?.querySelector(".cross-sell-hidden-input");
      console.log('SELECTED COLOR: ', swatch.dataset.colorValue);
      if (hiddenInput) {
        hiddenInput.dataset.variantId = e.target.value; 
      }
      for (const img of swatch.closest(".pdp-cross-sell-item").querySelectorAll(".pdp-cross-sell-image")) {
          if (img.dataset.variantTitle === swatch.dataset.colorValue) {
              img.classList.remove("hidden");
          } else {
              img.classList.add("hidden");
          }
      }
    }
  }
});


document.addEventListener('variant:added', (event) => {

    // If main ATC button is pressed (not "You may also like")
    if (event.target.classList.contains("PDP2025-form-element")) {
        const crossSellCheckboxes = document.querySelectorAll('[data-pdp-cross-sell-input]');

        // get
        let items = [];

        if (crossSellCheckboxes && crossSellCheckboxes.length > 0) {
            crossSellCheckboxes.forEach(checkbox => {
                if (checkbox.checked) {
                    const variantId = checkbox.getAttribute('data-variant-id');
                    const extraVariantIds = checkbox.getAttribute('data-extra-variant-ids');
                    if (extraVariantIds) {
                        const extraIdsArray = extraVariantIds.split(',');
                        extraIdsArray.forEach(extraId => {
                            if (extraId.trim() !== '') {
                                items.push({
                                    'id': extraId.trim(),
                                    'quantity': 1
                                });
                                console.log('Cross-sell extra item added:', extraId.trim());
                            }
                        });
                    }
                    if (variantId) {
                        items.push({
                            'id': variantId,
                            'quantity': 1
                        });
                        console.log('Cross-sell item added:', variantId);
                    }
                }
            });
        }

        if (items.length > 0) {
            let formData = { 'items': items };

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => response.json())
            .then(data => {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
                }));
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }
    }
});
  } catch(e) { console.error(e); }
})();

})();
